import { useAuthGlobalStore } from '@/stores/authGlobalStore'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'

export function useAppNavigation() {
  const authStore = useAuthGlobalStore()
  const restoStore = useRestoGLobalStore()

  const userSettingsNavLinks = [
    { name: 'Settings', route_name: 'setting', icon: 'Cog6ToothIcon' },
    // { name: 'Update Email', route_name: 'updateEmail' },
    { name: 'Update Password', route_name: 'updatePassword', icon: 'KeyIcon' }
  ]

  const giftVoucherNavLink = [{ name: 'Gift Vouchers', route_name: 'giftVoucher', icon: 'GiftIcon' }]
  const reservationNavLink = [{ name: 'Reservation', route_name: 'reservation', icon: 'CalendarDaysIcon' }]
  const menuNavLink = restoStore.MENU_URL
    ? [
        {
          name: 'Menu',
          route_name: 'menu',
          params: { menu_slug: restoStore.MENU_URL },
          query: {},
          icon: 'ClipboardDocumentListIcon'
        }
      ]
    : []
  const navLinks = [
    ...menuNavLink,
    ...(restoStore?.restoInfo?.is_gift_voucher_active ? giftVoucherNavLink : []),
    ...(restoStore?.restoInfo?.is_reservation_active ? reservationNavLink : []),
    { name: 'Signup', route_name: 'signup', icon: 'UserPlusIcon' },
    { name: 'Login', route_name: 'login', icon: 'ArrowRightOnRectangleIcon' }
  ]
  const loggedMenuNavLink = restoStore.MENU_URL
    ? [
        {
          name: 'Menu',
          route_name: 'menu',
          params: { menu_slug: restoStore.MENU_URL },
          query: {},
          icon: 'ClipboardDocumentListIcon'
        }
      ]
    : []
  const loggedNavLinks = [
    ...loggedMenuNavLink,
    { name: 'My Orders', route_name: 'my_orders', icon: 'ShoppingBagIcon' },
    ...(restoStore?.restoInfo?.is_gift_voucher_active ? giftVoucherNavLink : []),
    ...(restoStore?.restoInfo?.is_reservation_active ? reservationNavLink : []),
    { name: 'Settings', route_name: 'setting', icon: 'Cog6ToothIcon' },
  ]

  const getNavLinks = () => {
    return authStore.isLoggedIn ? loggedNavLinks : navLinks
  }

  // display these links as sublinks in the user settings page
  const getUserSettingsNavLinks = () => {
    return authStore.isLoggedIn ? userSettingsNavLinks : []
  }

  return {
    getNavLinks,
    getUserSettingsNavLinks
  }
}
